import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("@/pages/home/page"));
const AboutPage = lazy(() => import("@/pages/about/page"));
const ProductsPage = lazy(() => import("@/pages/products/page"));
const ServicesPage = lazy(() => import("@/pages/services/page"));
const ContactPage = lazy(() => import("@/pages/contact/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
